import * as Sentry from '@sentry/nextjs';

type CaptureContext = Parameters<typeof Sentry.captureException>[1];

const reportedErrors = new WeakSet<object>();

const isMarkable = (error: unknown): error is object =>
  typeof error === 'object' && error !== null;

export const wasReported = (error: unknown) =>
  isMarkable(error) && reportedErrors.has(error);

export const captureErrorOnce = (
  error: unknown,
  captureContext?: CaptureContext
) => {
  if (wasReported(error)) return;

  if (isMarkable(error)) reportedErrors.add(error);

  Sentry.captureException(error, captureContext);
};
